import { render, staticRenderFns } from "./modelConfiguration.vue?vue&type=template&id=ba1e9e6e&"
import script from "./modelConfiguration.vue?vue&type=script&lang=ts&"
export * from "./modelConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports